import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api, post, setToken, getToken, setUnauthorizedHandler } from "@/lib/api";

const Ctx = createContext({});
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const sent = useRef(false);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null));
    (async () => {
      try {
        const m = window.location.hash.match(/session_id=([^&]+)/);
        if (m && !sent.current) {
          sent.current = true;
          window.history.replaceState(null, "", window.location.pathname);
          try {
            const res = await post("/auth/session", { session_id: decodeURIComponent(m[1]) });
            setToken(res.session_token);
            setUser(res.user);
          } catch (e) { setError(e.message); }
          return;
        }
        if (getToken()) {
          try { setUser(await api("/auth/me")); } catch { setToken(null); }
        }
      } finally { setLoading(false); }
    })();
  }, []);

  const login = useCallback(() => {
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + "/")}`;
  }, []);
  const loginPassword = useCallback(async (identifier, password) => {
    const res = await post("/auth/password/login", { identifier: identifier.trim(), password });
    setToken(res.session_token);
    setUser(res.user);
  }, []);
  const logout = useCallback(async () => {
    try { await post("/auth/logout"); } catch {}
    setToken(null);
    setUser(null);
  }, []);
  return <Ctx.Provider value={{ user, setUser, loading, error, login, loginPassword, logout }}>{children}</Ctx.Provider>;
}
